import React, { useState, useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import VideoPlayer from './VideoPlayer'
import Test360 from './Test360'

import ReactImageMagnify from 'react-image-magnify'
import { handleADAOnGallery } from '../../utils/util'
import ClayLoadingIndicator from '@clayui/loading-indicator'

const Carousel = () => {
    const [shownItem, setShowItem] = useState(0)
    const [images, setImages] = useState([])

    // const [images, setImages] = useState([
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/1.jpg', inherited: true, key: 1 },
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/2.jpg', inherited: true, key: 2 },
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/3.jpg', inherited: true, key: 3 },
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/4.jpg', inherited: true, key: 4 },
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/5.jpg', inherited: true, key: 5 },
    //     { imageURL: '/o/bosch-autoparts-theme/images/carousel-test-images/6.jpg', inherited: true, key: 6 }
    // ])

    const [isRendered, setIsRendered] = useState(false)

    const handleShowItem = (e, item) => {
        setShowItem(item)
        performAnalyticsStep('image' + (item + 1)) //Priti for pefomance Analatic
    }
    const handleSetImages = images => setImages(images)
    const handleIsRendered = isRendered => setIsRendered(isRendered)
    const performAnalyticsStep = element => {
        // debugger;
        //alert('22');
        // console.log('element==' + element);
        //console.log(document.getElementById('productTitle').innerText);
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            event: 'pdp interaction',
            pdp_section: 'product images', //e.g.:social
            pdp_element: element, //e.g.:twitter
            id: productDetail.product.name, //e.g.:12345
        })
    }

    const performAnalyticsStepforProductDetails = element => {
        var x = productDetail.bapBreadcrumb.length - 2
        window.dataLayer = window.dataLayer || []
        dataLayer.push({
            event: 'view_item',
            items: [
                {
                    item_id: productDetail.product.partId, //e.g.:FS260E
                    item_name: productDetail.product.name, //e.g.:FOCUS Windshi...
                    item_brand: 'bosch', //e.g.:bosch
                    item_category: productDetail.bapBreadcrumb[x].name, //e.g.:winter blades
                },
            ],
        })
    }
    let [intervalId, setIntervalId] = useState(undefined)

    useEffect(() => {
        handleADAOnGallery()
    })

    useEffect(() => {
        loadProductDetail()
    }, [])

    const loadProductDetail = () => {
        intervalId = setInterval(handleOnLoadProductDetail, 250)
        setIntervalId(intervalId)
        performAnalyticsStepforProductDetails('')
    }

    const handleOnLoadProductDetail = () => {
        if (window.productDetail !== undefined) {
            if (intervalId !== undefined) {
                clearInterval(intervalId)
            }
            getProductImages()
        }
    }

    const getProductImages = () => {
        if (window.productDetail !== undefined) {
            let productImages = window.productDetail.images

            if (productImages) {
                handleSetImages(productImages)
                handleIsRendered(true)
            }
        }
    }

    const handlePrevFilmStrip = e => {
        scrollLeft(document.getElementById('filmStrip'), -130, 250)
        performAnalyticsStep('previous')
    }

    const handleNextFilmStrip = e => {
        scrollLeft(document.getElementById('filmStrip'), 132, 250)
        performAnalyticsStep('next')
    }

    const handlePrev = e => {
        if (shownItem === 0) {
            setShowItem(images.length - 1)
            scrollLeft(document.getElementById('filmStrip'), 1000, 250)
        } else {
            setShowItem(shownItem - 1)
            syncThumbnailCarousel(shownItem - 1)
            performAnalyticsStep('previous')
        }
    }

    const handleNext = e => {
        if (shownItem === images.length - 1) {
            setShowItem(0)
            scrollLeft(document.getElementById('filmStrip'), -1000, 250)
        } else {
            setShowItem(shownItem + 1)
            syncThumbnailCarousel(shownItem + 1)
            performAnalyticsStep('next')
        }
    }

    function syncThumbnailCarousel(shownItemIndex) {
        var filmStrip = document.getElementById('filmStrip')
        var filmStripWidth = document.getElementById('filmStrip').offsetWidth
        var thumbnailWidth = document.getElementById('goToItem-1').offsetWidth + 12 // Added margin that is Applied to thumbnail
        var currentLeft = filmStrip.scrollLeft
        var newCenter = thumbnailWidth * shownItemIndex
        var newLeft
        if (Math.round(filmStripWidth / thumbnailWidth) < 5) {
            newLeft = newCenter - thumbnailWidth
        } else {
            newLeft = newCenter - thumbnailWidth * 2
        }
        var change = newLeft - currentLeft
        scrollLeft(filmStrip, change, 250)
    }

    function scrollLeft(element, change, duration) {
        var start = element.scrollLeft,
            currentTime = 0,
            increment = 20

        var animateScroll = function() {
            currentTime += increment
            var val = Math.easeInOutQuad(currentTime, start, change, duration)
            element.scrollLeft = val
            if (currentTime < duration) {
                setTimeout(animateScroll, increment)
            }
        }
        animateScroll()
    }

    const getYoutubeThumbnail = image => {
        if (image) {
            let videoId = ''
            let regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
            let match = getImageUrl(image).match(regExp)
            if (match && match[2].length == 11) {
                videoId = match[2]
            }

            const thumbnail = 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg'
            //console.log(thumbnail)

            return thumbnail
        }
    }

    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    Math.easeInOutQuad = function(t, b, c, d) {
        t /= d / 2
        if (t < 1) return (c / 2) * t * t + b
        t--
        return (-c / 2) * (t * (t - 2) - 1) + b
    }

    const getImageUrl = image => {
        if (image.imageURL || image.imageLargeURL) {
            return image.imageURL || image.imageLargeURL
        } else {
            return ''
        }
    }
    const get360ImageUrl = image => {
        if (image['360_Identifier']) {
            let cdn_prefix = "";
            if (Liferay.ThemeDisplay.getLayoutURL().includes('www.boschautoparts.com"')) {
                cdn_prefix = 'https://test-cdn-qa-private-endpoint.azureedge.net/autopartqausstgcdntest/Prod'
            } else {
                cdn_prefix = 'https://test-cdn-qa-private-endpoint.azureedge.net/autopartqausstgcdntest'
            }
            const url =
               cdn_prefix + '/Assets/360/' +
                image['360_Identifier'] +
                '/' +
                image['360_Identifier'].substring(0, 10) +
                '001.jpg'
            return url
        } else {
            return ''
        }
    }

    const hasYoutubeUrl = image => {
        if (image) {
            const url = getImageUrl(image)
            if (url.length > 5) {
                return url.includes('youtu')
            } else {
                return false
            }
        } else {
            return false
        }
    }

    const has360Url = image => {
        if (image['360_Identifier'] === undefined) {
            return false
        } else {
            return true
        }
    }

    return (
        <>
            {!isRendered && <ClayLoadingIndicator small />}
            {isRendered && (
                <>
                    <div className="gallery-wrapper">
                        {images.length > 0 ? (
                            <Fragment>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="items">
                                            {images.map((image, index) => {
                                                if (has360Url(image)) {
                                                    return (
                                                        <Fragment key={index}>
                                                            {shownItem === index ? (
                                                                <div id={'item-' + index} key={index} className="item">
                                                                    <Test360
                                                                        amount={24}
                                                                        identifier={image['360_Identifier']}
                                                                        indexVal={index}
                                                                        paddingIndex="true"
                                                                    ></Test360>
                                                                </div>
                                                            ) : null}
                                                        </Fragment>
                                                    )
                                                } else if (hasYoutubeUrl(image)) {
                                                    const videoJsOptions = {
                                                        autoplay: false,
                                                        playbackRates: [0.5, 1, 1.25, 1.5, 2],
                                                        /* width: 635,*/
                                                        height: 570,
                                                        // responsive: true,
                                                        // fill: true,
                                                        controls: true,
                                                        techOrder: ['html5', 'youtube'],

                                                        sources: [
                                                            {
                                                                src: `${getImageUrl(image)}`,
                                                                type: 'video/youtube',
                                                            },
                                                        ],
                                                    }

                                                    return (
                                                        <Fragment key={index}>
                                                            {shownItem === index ? (
                                                                <div id={'item-' + index} key={index} className="item">
                                                                    <VideoPlayer {...videoJsOptions} />
                                                                </div>
                                                            ) : null}
                                                        </Fragment>
                                                    )
                                                } else {
                                                    return (
                                                        <Fragment key={index}>
                                                            {shownItem === index ? (
                                                                <>
                                                                    <ReactImageMagnify
                                                                        {...{
                                                                            smallImage: {
                                                                                alt: 'carousel image',
                                                                                isFluidWidth: true,
                                                                                src: getImageUrl(image),
                                                                            },
                                                                            largeImage: {
                                                                                src: getImageUrl(image),
                                                                                width: 1400,
                                                                                height: 1000,
                                                                                enlargedImageClassName: 'bg-white',
                                                                            },
                                                                            enlargedImageContainerClassName: 'bg-white',
                                                                            className: 'item zindex',
                                                                            key: index,
                                                                            enlargedImageContainerDimensions: {
                                                                                width: 350,
                                                                                height: '100%',
                                                                            },
                                                                        }}
                                                                    />
                                                                </>
                                                            ) : null}
                                                        </Fragment>
                                                    )
                                                }
                                            })}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="control-bar">
                                            <div style={{ margin: '0.35rem' }} className="pull-left">
                                                {shownItem + 1} / {images.length}
                                            </div>
                                            <div className="prev" onClick={e => handlePrev(e)}>
                                                <i className="bap-icon bap-left" aria-hidden="true"></i>
                                            </div>
                                            <div className="next" onClick={e => handleNext(e)}>
                                                <i className="bap-icon bap-right" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="filmStripWrapper">
                                            <div className="filmStripControls">
                                                <div className="prev" onClick={e => handlePrevFilmStrip(e)}>
                                                    <i className="bap-icon bap-left" aria-hidden="true"></i>
                                                </div>{' '}
                                                <br />
                                                <div className="next" onClick={e => handleNextFilmStrip(e)}>
                                                    <i className="bap-icon bap-right" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                            <div id="filmStrip" className="filmStrip">
                                                {images.map((image, index) => {
                                                    if (has360Url(image)) {
                                                        return (
                                                            <div onClick={e => handleShowItem(e, index)} key={index}>
                                                                <div className="three-sixty-image-overlay">
                                                                    <i
                                                                        className="bap-icon bap-rotations-360"
                                                                        aria-hidden="true"
                                                                    ></i>
                                                                </div>
                                                            </div>
                                                        )
                                                    } else if (hasYoutubeUrl(image)) {
                                                        return (
                                                            <div
                                                                onClick={e => handleShowItem(e, index)}
                                                                id={'goToItem-' + index}
                                                                key={index}
                                                                style={{ position: 'relative' }}
                                                            >
                                                                <img
                                                                    className="youtubeItem"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        height: '100%',
                                                                        margin: 0,
                                                                    }}
                                                                    key={index}
                                                                    src={getYoutubeThumbnail(image)}
                                                                    alt={getYoutubeThumbnail(image)}
                                                                />

                                                                <img
                                                                    className="youtubeIcon"
                                                                    style={{ position: 'absolute' }}
                                                                    id={'goToItem-' + index}
                                                                    key={index}
                                                                    src="/o/bosch-autoparts-theme/images/youtube-button.png"
                                                                    alt={getYoutubeThumbnail(image)}
                                                                />
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <div
                                                                id={'goToItem-' + index}
                                                                key={index}
                                                                onClick={e => handleShowItem(e, index)}
                                                            >
                                                                <img
                                                                    className="filmStripItem"
                                                                    src={getImageUrl(image)}
                                                                    alt={'Image-' + index}
                                                                />
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        ) : (
                            <div>
                                <p className="font-weight-bold text-center border mt-5 mb-5 pt-5 pb-5">
                                    {Liferay.Language.get('placeholder-no-images-available')}{' '}
                                </p>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    )
}

Carousel.propTypes = {
    width: PropTypes.number,
    unit: PropTypes.string,
}

export default Carousel
